export default "__VITE_ASSET__C55BdN7o__"